class ToggleMetro extends HideBase {
    constructor(el) {
        super(el, 'metro', 'MetroLineSelect__item', (el) => {
            el.parentElement.classList.add('MetroLineSelect--active');
        }, window.$isMobile ? null : 0);
    }
}

document.querySelectorAll('.ModalSelectMetro').forEach((modal) => {
    new ModalCounter(modal, '.MetroStationSelect__list input', declensionStation);
    const toggle = new ToggleMetro(modal.querySelector('.ModalSelectMetro__body'));
    const searchableInput = modal.querySelector('.SearchableInput');

    const rootTriggers = modal.querySelector('.MetroLineSelect');
    document.querySelectorAll('.MetroStationSelect__close').forEach((trigger) => {
        trigger.addEventListener('click', () => {
            rootTriggers.classList.remove('MetroLineSelect--active');
            toggle.deactivationAll();
        });
    });

    if(searchableInput) {
        searchableInput.addEventListener('select', (e) => {
            const input = modal.querySelector(`input[value="${e.detail.value}"]`);
            if(input) {
                input.checked = true;
            }
        });
    }
})

